'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/function-bind/index.js
// module id = 20
// module chunks = 20216485166878 72576805601409 114276838955818 211741474912242 256957939565513